import Data from "../controls/Data";
import { retry } from "../utils/http";
import { DataRequest } from "../controls/Data.default";
import { companyPoliciesViewColumns } from "./CompanyPoliciesView.default";
import { getCompanyPolicies } from "../repository/data.repository";
import { Row } from "antd";

export interface CompanyPoliciesViewProps {
  readonly onAction?: (key: string, record: any) => void;
}

function CompanyPoliciesView(props: CompanyPoliciesViewProps) {
  const request = ({ context, pageNumber, pageSize, sort }: DataRequest) => {
    const sortBy = (sort || [])[0]?.key ?? null;
    const sortDescending = (sort || [])[0]?.direction === "desc";

    return retry(() =>
      getCompanyPolicies({
        searchQuery: { conditions: [] },
        pageNumber,
        pageSize,
        ...(sortBy
          ? {
              sortBy,
              sortDescending,
            }
          : {}),
      }),
    ).then(({ data, totalRecords }) => ({
      data,
      pageNumber,
      pageSize,
      total: totalRecords,
    }));
  };

  function onAction(key: string, record: any): void {
    props.onAction?.(key, record);
  }

  return (
    <Row className="flex flex-auto flex-row flex-nowrap overflow-hidden">
      {/* Data */}
      <Data
        columns={companyPoliciesViewColumns}
        context={null}
        pageSize={100}
        actions={[
          {
            key: "preview",
            label: "Preview",
            handler: onAction,
          },
          {
            key: "monitor",
            label: "Acknowledgments",
            handler: onAction,
          },
        ]}
        hideHeader
        request={request}
        rowKey={({ uid }) => uid}
      />
    </Row>
  );
}

export default CompanyPoliciesView;
